import React, { Dispatch } from 'react';
import { Table } from 'reactstrap';
import { IPollingQrReportProps } from '../../../../models/pages/pollingQr';
import SortedColumn from '../../../table/sorted-column';
import Paginate from '../../../table/paginate';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAttendanceDate } from '../../../../models/components/qrPolling';
import { Confirm } from '../../../notification/main';
import { IAction, IAppState } from '../../../../models/action/core';
import { IAttendanceList } from '../../../../models/components/add-qr-polling';
import { connect } from 'react-redux';
import * as Actions from '../../../../store/actions/qrPolling';
import * as BackGroundActions from '../../../../store/actions/background';
import moment from 'moment';
import Loading from '../../../loading/loading';
import ContentLoader from 'react-content-loader';
import Select from 'react-select';
import { Log } from 'ng2-logger';
import { Button } from '../../../ui-elements/main';

const T = Translator.create();
const _logger = Log.create('polling-report-table');

const options = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
];
class QrPollingReportTable extends React.Component<IPollingQrReportProps, any> {

    public state = {
        isAll: false,
        selectedAttendaceIds: [] as string[],
        disAllowedAttendanceIds: [] as string[],
        selectedTakeOption: { value: 10, label: '10' },
        filters: {
            orderBy: '',
            query: '',
            page: 1,
            total: -1,
            skip: 0,
            take: 10
        }
    };

    onPageChange = (page: number) => {
        this.props.filters.page = page;
        this.props.onChange(page)
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;

        this.setState({
            isAll: isChecked,
            disAllowedAttendanceIds: [],
            selectedAttendaceIds: []
        });
    };


    onSelectAttendance = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { isAll, selectedAttendaceIds, disAllowedAttendanceIds } = this.state;
        const id = event.currentTarget.dataset.id ?? '';
        const isChecked = event.target.checked;

        if (!id) return;

        const updateIds = (ids: string[], id: string, isChecked: boolean) => {
            const updatedIds = [...ids];
            const index = updatedIds.indexOf(id);

            if (isChecked && index === -1) {
                updatedIds.push(id);
            } else if (!isChecked && index !== -1) {
                updatedIds.splice(index, 1);
            }

            return updatedIds;
        };

        if (!isAll) {
            this.setState({ selectedAttendaceIds: updateIds(selectedAttendaceIds, id, isChecked) });
        } else {
            this.setState({ disAllowedAttendanceIds: updateIds(disAllowedAttendanceIds, id, !isChecked) });
        }
    };

    isChecked = (itemId: string) => {
        const { isAll, selectedAttendaceIds, disAllowedAttendanceIds } = this.state;

        if (!isAll) {
            return selectedAttendaceIds.includes(itemId);
        }

        return !disAllowedAttendanceIds.includes(itemId);
    }

    deleteSelectedAttendanceConfirm = () => {
        Confirm.setConfirm(
            'normal',
            () => this.deleteSelectedAttendance(),
            (this.state.selectedAttendaceIds && this.state.selectedAttendaceIds.length > 1) ? T.t('r_delete_attendances_confirm_message') : T.t('r_delete_attendance_confirm_message'),
            null
        );
    };

    deleteSelectedAttendance = () => {
        this.props.dispatch(Actions.DeleteAttendances(this.state.isAll, this.state.isAll ? this.state.disAllowedAttendanceIds : this.state.selectedAttendaceIds, this.state.disAllowedAttendanceIds, this.props.coursePageClassId, () => { this.onCompletedProcess("delete") }, 'DeleteAttendances', 'get'));
    }

    downloadSelectedAttendances = (attendanceId?: string) => {

        const { selectedAttendaceIds, disAllowedAttendanceIds, isAll } = this.state;

        const attendanceIds = attendanceId
            ? [attendanceId]
            : selectedAttendaceIds;

        if (attendanceIds.length || this.state.isAll) {
            this.props.dispatch(
                BackGroundActions.GetAttendanceExcelDownload(
                    isAll ? disAllowedAttendanceIds : attendanceIds,
                    isAll,
                    this.props.coursePageClassId ?? "",
                    this.props.coursePageActivityId ?? "",
                    this.onCompletedProcess,
                    'GetAttendanceExcelDownload',
                    'get'
                )
            );
        }
    };

    onCompletedProcess = async (type?: string) => {
        this.setState({
            selectedAttendaceIds: [],
            disAllowedAttendanceIds: [],
            isAll: false
        });

        if (type && type == "delete") {
            this.props.onChange(this.props.filters.page)
        }
    };

    public onChangeTake = (event: any) => {
        this.setState({ selectedTakeOption: event });
        this.props.filters.take = event.value;
        this.props.filters.page = 1;
        this.getAttendanceList();
    };

    public sort = (sortKey: string, orderBy: string) => {
        this.props.filters.orderBy = sortKey + '_' + orderBy;
        this.getAttendanceList();
    };

    getAttendanceList() {
        this.props.dispatch(Actions.GetAttendancesList(this.props.coursePageClassId ?? "-1", this.props.filters.page, "", this.props.filters.take, this.props.filters.orderBy, 'getAttendancesList', 'get'));
    }

    public render() {
        const { results, filters } = this.props;
        const loadingSpaces = 64;
        return (
            <>
                <div className='d-flex justify-content-between'>
                    <div className='d-flex gap-2'>
                        {(this.state.isAll || this.state.selectedAttendaceIds.length > 0) && (
                            <>
                                <Button
                                    onClick={this.deleteSelectedAttendanceConfirm}
                                    text={T.t('r_delete_selected_attendances')}
                                    materialicon='delete'
                                    button_type={'secondary'}
                                    size={'medium'} />
                                <Button
                                    onClick={() => this.downloadSelectedAttendances()}
                                    text={T.t('r_download_selected_attendances')}
                                    button_type={'secondary'}
                                    materialicon='archive'
                                    size={'medium'} />

                            </>
                        )}
                    </div>
                    <div className='d-flex gap-2'>
                        <Button
                            onClick={this.props.onModalChange()}
                            button_type='primary'
                            size='medium'
                            iconPosition='left'
                            materialicon='add'
                            text={T.t('r_create_qr_code')} />
                        <div className='k365-input  minw-90'>
                            <Select className='k365-select' options={options} value={this.state.selectedTakeOption} onChange={this.onChangeTake} />
                        </div>
                    </div>


                </div>
                <Loading spinnerId={'getAttendancesList'} width={'100%'}>
                    <div style={{ backgroundColor: '#eeede9' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox="0 0 700 400"
                            style={{ width: '100%' }}
                        >
                            <circle cx="36" cy="64" r="20" />
                            <rect x="66" y="60" rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 60} r="20" />
                            <rect x="66" y={loadingSpaces + 56} rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 120} r="20" />
                            <rect x="66" y={loadingSpaces + 116} rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 180} r="20" />
                            <rect x="66" y={loadingSpaces + 176} rx="5" ry="5" width="600" height="12" />
                            <circle cx="36" cy={loadingSpaces + 240} r="20" />
                            <rect x="66" y={loadingSpaces + 236} rx="5" ry="5" width="600" height="12" />
                        </ContentLoader>
                    </div>
                </Loading>
                <div id='getAttendancesList_Content' style={{ width: "-webkit-fill-available" }}>
                    <Table className="table-user-list table-ellipsis table-mobile mt-2" striped={true} hover={true} borderless={true}>
                        <thead>
                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                <th className='d-lg-table-cell d-xl-table-cell text-center'>
                                    <div className="w-auto tick-radio position-relative">
                                        <input onChange={this.selectAll} style={{ zIndex: "0" }} type="checkbox" checked={this.state.isAll || this.state.selectedAttendaceIds.length === this.props.filters.total} name="allSelectedAttendace" defaultValue="one" id="radio-three" className="form-radio" />
                                    </div>
                                </th>
                                <SortedColumn
                                    datacell="createdDate"
                                    className=" d-lg-table-cell d-xl-table-cell text-center"
                                    title={T.t('r_attendance_created_date')}
                                    sortkey="CreatedDate"
                                    sortedcolumn={this.state.filters.orderBy}
                                    sort={this.sort}
                                />
                                <SortedColumn
                                    datacell="createdByUserFullname"
                                    className=" d-lg-table-cell d-xl-table-cell text-center"
                                    title={T.t('r_createdby_attendance')}
                                    sortkey="CreatedByUserFullname"
                                    sortedcolumn={this.state.filters.orderBy}
                                    sort={this.sort}
                                />
                                <th className='d-lg-table-cell d-xl-table-cell text-center'>
                                    <span>{T.t('r_participated_and_total')}</span>
                                </th>
                                <th className='d-lg-table-cell d-xl-table-cell text-center'>
                                    <span>{T.t('r_lesson_homePage_processes')}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {results && Array.isArray(results) && results?.map((item: IAttendanceDate) => {
                                return (
                                    <tr key={'attendance-' + item.id} data-title={item.id} style={{ cursor: 'initial' }}>
                                        <td>
                                            <div className="w-auto tick-radio position-relative">
                                                <input
                                                    onChange={this.onSelectAttendance}
                                                    checked={this.isChecked(item.id)}
                                                    data-id={item.id}
                                                    type="checkbox"
                                                    name="demo"
                                                    defaultValue="one"
                                                    id="radio-three"
                                                    className="form-radio"
                                                    style={{ zIndex: "0" }}
                                                />
                                            </div>
                                        </td>
                                        <td data-label={T.t('r_firstname')} className="text-center">
                                            {moment(item?.attendanceCreatedDate).format('DD.MM.YYYY HH:mm')}
                                        </td>
                                        <td data-label={T.t('r_lastname')} className="text-center">
                                            {item?.cratedByUserFullname}
                                        </td>
                                        <td data-label={T.t('r_username')} className="text-center">
                                            {item?.participantCount} / {item?.totalCount}
                                        </td>
                                        <td data-label={T.t('r_username')} className="text-center">
                                            <Button
                                                onClick={() => this.downloadSelectedAttendances(item.id)}
                                                button_type='primary'
                                                size='medium'
                                                iconPosition='left'
                                                materialicon='cloud_download'
                                                text={T.t('r_download')} />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>

                    </Table>

                    {(results && results?.length > 0) && (
                        <div className="row-options justify-content-end">
                            <div
                                className="page-sorting d-flex align-items-center justify-content-center"
                                style={{ marginTop: '5px' }}
                            />
                            <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                        </div>
                    )}
                </div>
            </>
        );
    }
}


const mapStateToProps = (state: IAppState, ownProps: IAttendanceList): IAttendanceList => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAttendanceList = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CQrPollingReportTable = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(QrPollingReportTable);

export default CQrPollingReportTable;
